import React from 'react';

import { OverflowAvatarStack } from '../OverflowAvatarStack';
import { REPORTING_LINES_USER_CARD_SLOTS_LIMIT } from '../ReportingLinesChart';
import { MissingProfileCard } from '../ReportingLinesUserCard';
import * as Styled from '../styles';
import { type ReportingLinesUser } from '../types';

import { renderReportingLinesUserCard, ReportingLinesUserCardWithLine } from './shared';
import { getUsersForLayoutSections } from './util';

interface DirectReportsSectionProps {
	selectedUser: ReportingLinesUser;
	directReports: ReportingLinesUser[];
	showAvatarStack: boolean;
	toggleAvatarStack: () => void;
}

export const DirectReportsSection = ({
	selectedUser,
	directReports,
	showAvatarStack,
	toggleAvatarStack,
}: DirectReportsSectionProps) => {
	const { usersForCards, usersForAvatarStack, numMissingProfiles } = getUsersForLayoutSections(
		directReports,
		showAvatarStack ? REPORTING_LINES_USER_CARD_SLOTS_LIMIT : undefined,
	);

	return (
		<>
			<ReportingLinesUserCardWithLine user={selectedUser} selected testId="selected-user-card" />
			<Styled.ReportsList testId="direct-reports-section">
				{usersForCards.map((user, index) =>
					renderReportingLinesUserCard(user, `direct-report-${index}`),
				)}
				{!usersForAvatarStack && numMissingProfiles > 0 && (
					<MissingProfileCard
						numMissingProfiles={numMissingProfiles}
						testId="missing-reports-card"
					/>
				)}
				{usersForAvatarStack && (
					<Styled.ReportsStackContainer>
						<OverflowAvatarStack
							atlassianUsers={usersForAvatarStack}
							numFilteredMissingProfiles={numMissingProfiles}
							onClick={toggleAvatarStack}
						/>
					</Styled.ReportsStackContainer>
				)}
			</Styled.ReportsList>
		</>
	);
};
